import { addMonths, isAfter, isBefore, parseISO, startOfDay } from 'date-fns'
import { isEmpty } from 'lodash'

export const isDataAgendamentoInvalida = (data: string) =>
  isEmpty(data) || isAfter(parseISO(data), addMonths(new Date(), 6)) || isBefore(parseISO(data), startOfDay(new Date()))
